import { Autocomplete, Divider, Grid, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import ContactCardTemplate from './contactCardTemplate'
import { campaignContactFieldData, createCampaignContactFieldPayload, getCampaignContactListResponse, getListOfCampaignContactFieldResponse, importCampaignContactDataPayload, tagDataInterface, updateCampaignContactFieldPyload } from '../../../models/axiosModel';
import { ContactContext, ContactContextPayload } from '../../../context/contactContext';
import style from "../../../assets/styles/componentStyles/feedbackStyles/feedbackStyle.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import mappingStyles from './../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss'
import GlobalButton from '../../utility/globalButton/button';
import uploadGif from "../../../assets/images/campaignContact/upload.gif";
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useSearchParams } from 'react-router-dom';
import CreateSingleContact from './createSingleContact';
import { flagAddTagDialogObj } from './contactsGlobal';
import { tertiaryColor } from '../../../utils/colors';
import { parsePhoneNumber } from 'libphonenumber-js/mobile';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { getFileTypeImgIcon } from '../../../utils/constants';
import InValidContact from './inValidContact';
import agent from '../../../services/api';
import { isDefaultContactField, isRequiredContactField, SAMPLE_CONTACT_CSV_DOCUMENT } from './contactConstant';
import Required from '../../utility/required';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import clsx from 'clsx';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';

interface CreateNewContactPopupProps {
    selectedCampaignContactList: getCampaignContactListResponse,
    importCampaignContactDataApiCall: (payload: importCampaignContactDataPayload) => void,
    setFlagOnOkayClick: React.Dispatch<React.SetStateAction<boolean>>,
    getListOfCampaignFieldTypeApiCall: () => void,
    getListOfCampaignContactFieldApiCall: (list_id: number) => Promise<void>,
    createCampaignContactFieldApiCall: (payload: createCampaignContactFieldPayload) => void,
    updateCampaignContactFieldApiCall: (payload: updateCampaignContactFieldPyload) => void,
    deleteCampaignContactFieldApiCall: (contact_field_id: number) => void,  

    setFlagAddTagDialogObj: React.Dispatch<React.SetStateAction<flagAddTagDialogObj>>,
    getCampaignContactApiCall: (list_id: number) => void,
    getCountryCodeApiCall: () => Promise<void>,
    onClickOfCustomTagOption: (flagEditTagPopup: boolean, flagEditTag: boolean, tag?: tagDataInterface) => void,
    onClickOfDeleteTag: (tag: tagDataInterface) => void,
}

export interface progressInterface {
    filename: string,
    percent: number,
}

const CreateNewContactPopup: React.FC<CreateNewContactPopupProps> = ({ selectedCampaignContactList, importCampaignContactDataApiCall, setFlagOnOkayClick, getListOfCampaignFieldTypeApiCall, getListOfCampaignContactFieldApiCall, createCampaignContactFieldApiCall, updateCampaignContactFieldApiCall, deleteCampaignContactFieldApiCall, setFlagAddTagDialogObj, getCampaignContactApiCall, getCountryCodeApiCall, onClickOfCustomTagOption, onClickOfDeleteTag }) => {
    const { campaignContactFieldData, setFlagCreateNewContactDialog, campaignContactFieldTypeData } = useContext(ContactContext) as ContactContextPayload;
    const { setFlagLoading, flagLoading } = useContext(UserContext) as UserContextPayload;

    const { showError } = useGenericStore(useShallow((state) => ({
        showError: state.showError
    })))

    const [files, setFiles] = useState<any>([]);
    const [progress, setProgress] = useState<progressInterface>({ filename: "", percent: 0 });

    const [flagCreateContact, setFlagCreateContact] = useState<boolean>(true);
    const [flagCreateSingleContact, setFlagCreateSingleContact] = useState<boolean>(false);
    const [flagMapTheField, setFlagMapTheField] = useState<boolean>(false);
    const [flagProcessingContact, setFlagProcessingContact] = useState<boolean>(false);

    const [flagShowInCorrectPhoneNumber, setFlagShowInCorrectPhoneNumber] = useState<boolean>(false);
    const [validatePhoneNumber, setValidatePhoneNumber] = useState<any[] | null>(null);

    const [fieldsOfCSV, setFieldsOfCSV] = useState<string[]>([]);
    const [jsonArray, setJsonArray] = useState<null | any[]>(null);
    const [dummyCampaignContactFieldData, setDummyCampaignContactFieldData] = useState<getListOfCampaignContactFieldResponse | null>(null);
    const [editingFieldIndex, setEditingFieldIndex] = useState<number | null>(null);
    const [originalFieldName, setOriginalFieldName] = useState<string>("");
    const [fieldToDelete, setFieldToDelete] = useState<campaignContactFieldData | null>(null);

    const [mapTheField, setMapTheField] = useState<(string)[]>([]);
    const [dropdownOptions, setDropdownOptions] = useState<string[]>([]);

    const [searchParams] = useSearchParams();
    const list_id = searchParams.get('contact_list_id');

    const innerHeight = window.innerHeight - 130;

    const validatePhoneNumbers = (jsonArray: any[]) => {  

        let phoneNumberCSVField="", countryCodeCSVField="";
        campaignContactFieldData?.contact_field_data.sort((a, b) => a.contact_field_seq - b.contact_field_seq).map((field, ind) => {
            if(field.contact_field_name.toLowerCase() == "phone number"){
                phoneNumberCSVField = mapTheField[ind];
            } else if(field.contact_field_name.toLowerCase() == "country code" || field.contact_field_name.toLowerCase() == "country_code"){
                countryCodeCSVField = mapTheField[ind];
            }
        })

        return jsonArray.map((json: any) => {
            if(countryCodeCSVField in json && json[countryCodeCSVField]?.length > 0 && phoneNumberCSVField in json && json[phoneNumberCSVField]?.length > 0){
                try {
                    const validate = parsePhoneNumber(json[phoneNumberCSVField], json[countryCodeCSVField]);
                    if(validate.isValid() && validate.country == json[countryCodeCSVField] && (validate.getType()?.toLowerCase() == "undefined" ||  validate.getType()?.toLowerCase().indexOf('mobile') != -1 )){
                        return {
                            ...json, 
                            flag_validate: true, 
                            phoneNumberCSVField: validate.formatInternational().replace(/\D/g, ''),
                        }
                    }
                } catch (err) {
                    return {
                        ...json, 
                        flag_validate: false,
                    }
                }
            }
            return {
                ...json, 
                flag_validate: false,
            }
        })
    }

    const onClickOfImportButton = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        await getListOfCampaignContactFieldApiCall(Number(list_id));
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const uploadFileHandler = async (files: any[]) => { 
        const file: any = files[0];
        file.isUploading = true;
        setFiles([file]);

        let formData = new FormData()
        formData.append(
            "file", file, file.name,
        )
        formData.append("chatbot_flag", "true");

        let config = {
            onUploadProgress: (progressEvent: any) => {
                const { loaded, total } = progressEvent;
                var percent = Math.floor((loaded * 100) / total)
                setProgress({ ...progress, percent: percent, filename: file.name })
            }
        }

        setFlagLoading({ ...flagLoading, flagRoundLoader: true })
         try {
            const res = await agent.uploadFile.post(formData, config)

            if (res.status) {
                file.isUploading = false;
                file.file_data = res.data.data;
                file.google_storage_id = res.data.data.google_storage_id;

                await setFiles((old: any) => {
                    const temp = [...old];
                    const fileType = file.name.split('.').pop();
                    const fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? "";
                    temp.map((rr: any) => {
                        if (rr.google_storage_id === file.google_storage_id) {
                            rr.isUploading = false;
                            rr.file_data = res.data.data;
                            rr.google_storage_id = res.data.data.google_storage_id;
                            rr.previewImageSrc = fileTypeIconSrc;
                        }
                    });
                    return temp;
                });

                return res.data.data.google_storage_id;
            }
        } catch (err) {
            showError("Something went wrong!")
            setFiles([]);
            console.error(err);
        } finally {
            setFlagLoading({ ...flagLoading, flagRoundLoader: false });
        }

        return undefined;
    }

    const handleChangeField = (newValue: string | null, ind: number) => {
        setMapTheField((fields) => {
            return fields.map((field, index) => {
                if (index === ind) {
                    if (newValue) return newValue;
                    else return "";
                }
                return field;
            })
        })
    }

    const checkDisableContinue = () => {
        if (!mapTheField || mapTheField.length === 0) return true;

        if (!dummyCampaignContactFieldData) return false;

        const sortedFields = dummyCampaignContactFieldData.contact_field_data.sort((a, b) => a.contact_field_seq - b.contact_field_seq);

        const isRequiredFieldUnmapped = sortedFields.some((field, index) => {
            const fieldName = field.contact_field_name.toLowerCase();
            if(isRequiredContactField(fieldName)){
                return !mapTheField[index] || mapTheField[index].trim() === "";
            }
            return false;
        });

        return isRequiredFieldUnmapped;
    }

    const importContactDataPayload = (google_storage_id: number) => {
        if (campaignContactFieldData) {
            const mappingObj = campaignContactFieldData?.contact_field_data.sort((a, b) => a.contact_field_seq - b.contact_field_seq).map((data, ind) => {
                if (mapTheField[ind] && mapTheField[ind].length > 0) {
                    return {
                        contact_field_id: data.contact_field_id,
                        contact_import_log_mapping_value: mapTheField[ind],
                    }
                }
                return null;
            }).filter((item): item is { contact_field_id: number; contact_import_log_mapping_value: string; } => item !== null);

            return {
                contact_list_id: selectedCampaignContactList.contact_list_id,
                contact_import_log_google_storage_id: google_storage_id,
                contact_import_log_mapping: mappingObj,
            }
        }
    }

    const onClickOfContinueBtn = async () => {
        if(jsonArray){
            const updatedJson = validatePhoneNumbers(jsonArray);

            const correctPhoneNumber = updatedJson.filter((json) => json.flag_validate);
            
            setValidatePhoneNumber(correctPhoneNumber);
            setJsonArray(updatedJson);

            if(correctPhoneNumber.length == updatedJson.length){ // All the Contacts are Correct.
                const storageId = await uploadFileHandler(files);
                const payload = importContactDataPayload(storageId);
                if (payload) {
                    setFlagProcessingContact(true);
                    importCampaignContactDataApiCall(payload);
                }
            } else {
                setFlagShowInCorrectPhoneNumber(true);
            }

        }
    }

    const onNewFieldClick = () => {
        if (editingFieldIndex !== null) return;
        if (campaignContactFieldTypeData.length === 0) {
            getListOfCampaignFieldTypeApiCall();
        }
        if (dummyCampaignContactFieldData) {
            const dummyFields = { ...dummyCampaignContactFieldData };
            dummyFields.contact_field_data = [
                ...dummyFields.contact_field_data, 
                {
                    contact_field_id: 0,
                    flag_default: false,
                    contact_field_name: "",
                    contact_field_type_id: 0,
                    contact_field_type_name: "Text",
                    contact_field_seq: sortFields(dummyFields.contact_field_data)[dummyFields.contact_field_data.length - 1].contact_field_seq + 1,
                    created_at_timestamp: "",
                    updated_at_timestamp: "",
                }
            ]
            setDummyCampaignContactFieldData(dummyFields);
            setOriginalFieldName("");
            setEditingFieldIndex(dummyFields.contact_field_data.length - 1);
        }
    }

    const onEditFieldClick = (field: campaignContactFieldData, ind: number) => {
        if (editingFieldIndex !== null) return;
        setOriginalFieldName(field.contact_field_name);
        setEditingFieldIndex(ind);
    }

    const onDeleteFieldClick = (field: campaignContactFieldData) => {
        if (editingFieldIndex !== null) return;
        setFieldToDelete(field);
    }

    const onConfirmDeleteField = () => {
        if (fieldToDelete) {
            deleteCampaignContactFieldApiCall(fieldToDelete.contact_field_id);
            setFieldToDelete(null);
        }
    }

    const onBlurSave = async () => {
        if (editingFieldIndex === null || !dummyCampaignContactFieldData) {
            setEditingFieldIndex(null);
            return;
        }

        const currentIndex = editingFieldIndex;
        const field = dummyCampaignContactFieldData.contact_field_data[currentIndex];
        const trimmedName = field?.contact_field_name?.trim() ?? "";
        const isNewField = !field?.contact_field_id;

        if (isNewField) {
            setEditingFieldIndex(null);
            if (trimmedName.length > 0) {
                if (campaignContactFieldTypeData.length === 0) {
                    await getListOfCampaignFieldTypeApiCall();
                }
                const payload = {
                    contact_list_id: Number(list_id),
                    contact_field_data: [{
                        contact_field_type_id: campaignContactFieldTypeData?.find(
                            (type) => type.contact_field_type_name === "Text"
                        )?.contact_field_type_id ?? 1,
                        contact_field_name: trimmedName,
                    }]
                }
                createCampaignContactFieldApiCall(payload);
            } else {
                const dummyFields = { ...dummyCampaignContactFieldData };
                dummyFields.contact_field_data.pop();
                setDummyCampaignContactFieldData(dummyFields);
            }
            return;
        }

        setEditingFieldIndex(null);
        if (trimmedName.length === 0) {
            const dummyFields = { ...dummyCampaignContactFieldData };
            dummyFields.contact_field_data = dummyFields.contact_field_data.map((item, index) => {
                if (index === currentIndex) {
                    return { ...item, contact_field_name: originalFieldName };
                }
                return item;
            });
            setDummyCampaignContactFieldData(dummyFields);
            return;
        }

        const shouldUpdate = trimmedName !== originalFieldName?.trim();
        const normalizedName = shouldUpdate ? trimmedName : originalFieldName;

        // Always clear trailing/leading spaces from local state even when API is skipped
        if (field.contact_field_name !== normalizedName) {
            const dummyFields = { ...dummyCampaignContactFieldData };
            dummyFields.contact_field_data = dummyFields.contact_field_data.map((item, index) => {
                if (index === currentIndex) {
                    return { ...item, contact_field_name: normalizedName };
                }
                return item;
            });
            setDummyCampaignContactFieldData(dummyFields);
        }

        if (shouldUpdate) {
            if (campaignContactFieldTypeData.length === 0) {
                await getListOfCampaignFieldTypeApiCall();
            }
            const payload = {
                contact_list_id: Number(list_id),
                contact_field_id: field.contact_field_id,
                contact_field_type_id: campaignContactFieldTypeData?.find(
                    (type) => type.contact_field_type_name === "Text"
                )?.contact_field_type_id ?? field.contact_field_type_id ?? 1,
                contact_field_name: trimmedName,
            };
            updateCampaignContactFieldApiCall(payload);
        }
    }

    const sortFields = (fields: campaignContactFieldData[]) => {
        return fields.sort((a, b) => a.contact_field_seq - b.contact_field_seq);
    }

    const onClickOfCreateSingleContact = () => {
        setFlagCreateContact(false);
        setFlagCreateSingleContact(true);
    }

    useEffect(() => {
        if (campaignContactFieldData && fieldsOfCSV.length > 0) {
            const data = campaignContactFieldData.contact_field_data.sort((a, b) => a.contact_field_seq - b.contact_field_seq);
            if (data) {
                setMapTheField((prevMapFields) => {
                    // Preserve user-changed mappings when fields refresh (e.g. after creating a new field).
                    // Only auto name-match for newly added fields or on first init.
                    const isInitialMapping = prevMapFields.length === 0;
                    let mapFields: string[] = [];
                    for (let i = 0; i < data.length; ++i) {
                        if (!isInitialMapping && i < prevMapFields.length) {
                            mapFields.push(prevMapFields[i]);
                        } else if (fieldsOfCSV.find((field) => field === data[i].contact_field_name)) {
                            mapFields.push(data[i].contact_field_name);
                        } else {
                            mapFields.push("");
                        }
                    }
                    return mapFields;
                });
                if (!flagMapTheField && files.length > 0) setFlagMapTheField(true);
            }
        }
    }, [campaignContactFieldData])

    useEffect(() => {
        if (fieldsOfCSV.length > 0 && mapTheField.length > 0) {
            const commonFields = fieldsOfCSV
            // .filter((field) => !mapTheField.includes(field)); //commenting this because I want to give user to map same field as many times he wants
            setDropdownOptions(commonFields);
        }
    }, [mapTheField])

    useEffect(() => {
        if (campaignContactFieldData) {
            setDummyCampaignContactFieldData(campaignContactFieldData);
        }
    }, [campaignContactFieldData])

    const reUploadFileClick = () => {
        setFiles([]);
        setFlagShowInCorrectPhoneNumber(false);
        setFlagMapTheField(false);
        setFlagCreateContact(true);
        setJsonArray(null);
        setValidatePhoneNumber(null);
        setMapTheField([]);
        setFieldsOfCSV([]);
    }

    const importAnywayClick = async () => {
        if(!validatePhoneNumber || validatePhoneNumber.length == 0) return;
        
        const keys = Object.keys(validatePhoneNumber[0]);
        const rows = validatePhoneNumber.map((row) => keys.map(k => row[k] ?? "").join(","));

        const csvFile = [
            keys.join(","), // Header
            ...rows // CSV Content (Rows)
        ].join("\n");
        
        const blob = new Blob([csvFile], { type: 'text/csv' });
        const file = new File([blob], files[0].name, { type: 'text/csv' });

        const storageId = await uploadFileHandler([file]);
        const payload = importContactDataPayload(storageId);
        if (payload) {
            setFlagShowInCorrectPhoneNumber(false);
            setFlagProcessingContact(true);
            importCampaignContactDataApiCall(payload);
        }
    }

    const downloadSampleCSVTemplate = () => {
        window.open(SAMPLE_CONTACT_CSV_DOCUMENT);
    }
    
    const resetCommonState = () => {
        setFlagCreateSingleContact(false);
        setFlagMapTheField(false);
        setFlagProcessingContact(false);
        setFlagShowInCorrectPhoneNumber(false);
        setValidatePhoneNumber(null);
        setJsonArray(null);
        setFieldsOfCSV([]);
        setMapTheField([]);
        setDropdownOptions([]);
        setFiles([]);
    };
    
    const handleBackButtonClick = () => {
        if (flagMapTheField) {
            if(flagShowInCorrectPhoneNumber){
                setFlagMapTheField(true);
                setFlagCreateContact(false);
                setFlagProcessingContact(false);
                setFlagShowInCorrectPhoneNumber(false);
                setFlagCreateSingleContact(false);
            } else {
                setFlagMapTheField(false);
                resetCommonState();
            }
        }
        else {
            setFlagCreateContact(true);
            resetCommonState();
        }
    };

    return (
        <>
            {fieldToDelete &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${fieldToDelete.contact_field_name}`}
                    open={Boolean(fieldToDelete)}
                    onClose={() => setFieldToDelete(null)}
                    onDelete={() => onConfirmDeleteField()}
                />
            }
            <Grid container >
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"} sx={{ position: "relative" }}>
                            {(!flagCreateContact && !flagProcessingContact) &&
                                <ArrowBackIcon
                                    onClick={() => handleBackButtonClick()}
                                    className={style.backButtonStyle}
                                />
                            }
                            <Typography className={mappingStyles.popupTitleTypography}> 
                                { flagCreateContact 
                                    ? "Create New Contact" 
                                    : flagCreateSingleContact 
                                        ? "Create a Single Contact" 
                                            : !flagMapTheField 
                                                ? "Import Contact (Upload CSV File)" 
                                                    : flagProcessingContact 
                                                        ? "Import Contacts" 
                                                            : flagShowInCorrectPhoneNumber 
                                                                ? "Contact Validation Results" 
                                                                    : "Map The Fields"
                                }
                            </Typography>
                        </Grid>

                        <Divider className={mappingStyles.popupTitleDivider} />

                        <Grid item className={`${globalStyles.fullwidth} ${flagCreateSingleContact ? "" : globalStyles.overflowAuto}`} sx={flagCreateSingleContact ? {} : {maxHeight: `${innerHeight}px !important`}}>
                            <Grid container className={mappingStyles.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    {flagCreateContact ?
                                        <Grid container direction={"column"}>
                                            <Grid item>
                                                <Grid container justifyContent={"end"}>
                                                    <Grid item onClick={() => downloadSampleCSVTemplate()}>
                                                        <Typography className={mappingStyles.sampleCSVText}>Sample CSV</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item>
                                                <Grid container className={mappingStyles.createContactContainer}>
                                                    <Grid item className={mappingStyles.createContactGridItem}>
                                                        <Typography className={mappingStyles.contactOptionTypography} onClick={() => setFlagCreateContact(false)}>Import Contact (Upload CSV File)</Typography>
                                                    </Grid>
                                                    <Grid item className={mappingStyles.createContactGridItem}>
                                                        <Typography className={mappingStyles.contactOptionTypography} onClick={() => onClickOfCreateSingleContact()}>Create a Single Contact</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        :
                                        flagCreateSingleContact ?
                                            <CreateSingleContact
                                                getListOfCampaignContactFieldApiCall={getListOfCampaignContactFieldApiCall}
                                                setFlagAddTagDialogObj={setFlagAddTagDialogObj}
                                                getCampaignContactApiCall={getCampaignContactApiCall}
                                                getCountryCodeApiCall={getCountryCodeApiCall}
                                                onClickOfCustomTagOption={onClickOfCustomTagOption}
                                                onClickOfDeleteTag={onClickOfDeleteTag}
                                            />
                                            :
                                            !flagMapTheField ?
                                                <ContactCardTemplate
                                                    files={files}
                                                    setFiles={setFiles}
                                                    onClickOfImportButton={onClickOfImportButton}
                                                    setFieldsOfCSV={setFieldsOfCSV}
                                                    jsonArray={jsonArray}
                                                    setJsonArray={setJsonArray}
                                                    downloadSampleCSVTemplate={downloadSampleCSVTemplate}
                                                />
                                                :
                                                flagShowInCorrectPhoneNumber ? 
                                                    <>
                                                        <InValidContact
                                                            jsonArray={jsonArray as any[]}
                                                            validatePhoneNumber={validatePhoneNumber as any[]}
                                                            fieldsOfCSV={fieldsOfCSV}
                                                            mapTheField={mapTheField}
                                                            reUploadFileClick={reUploadFileClick}
                                                            importAnywayClick={importAnywayClick}
                                                        />
                                                    </>
                                                :
                                                    flagProcessingContact ?
                                                        <Grid container textAlign={"center"} gap={"12px"} justifyContent={"center"} alignItems={"center"}>
                                                            <Grid item xs={12}>
                                                                <img src={uploadGif} alt="upload gif" height={"120px"} width={"120px"} />
                                                            </Grid>
                                                            <Grid item xs={9}>
                                                                <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.primaryFontWeight} ${globalStyles.blackColor}`}>
                                                                    Please wait while we process your contact. It may take a few minutes to import all contacts.
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} mt={2} mb={2}>
                                                                <GlobalButton
                                                                    buttonText="Okay"
                                                                    sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                                    className='primaryButtonStyle'
                                                                    onClick={() => { setFlagOnOkayClick(true); setFlagCreateNewContactDialog(false); }}
                                                                >
                                                                </GlobalButton>
                                                            </Grid>
                                                        </Grid>
                                                        :
                                                        <Grid container>
                                                            <Grid item xs={6} marginBottom={"10px"}>
                                                                <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight} ${globalStyles.blackColor}`}>Contact List Fields</Typography>
                                                            </Grid>
                                                            <Grid item xs={6} marginBottom={"10px"}>
                                                                <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight} ${globalStyles.blackColor}`}>CSV Template Fields</Typography>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                {dummyCampaignContactFieldData && sortFields(dummyCampaignContactFieldData.contact_field_data).map((data: campaignContactFieldData, ind: number) => {
                                                                    const isDefaultField = isDefaultContactField(data);
                                                                    const isEditingField = editingFieldIndex === ind;
                                                                    return (
                                                                        <Grid key={ind} container flexWrap={"nowrap"} alignItems={"center"} className={mappingStyles.mappingFieldsContainer}>
                                                                            <Grid item xs={6} sx={{ background: tertiaryColor, padding: isEditingField ? "" : "12.5px 7px", minHeight: "46px" }} className={mappingStyles.fieldsLabelStyle}>
                                                                                {isEditingField ?
                                                                                    <TextField
                                                                                        className={mappingStyles.campaignContactFieldPopupTextField}
                                                                                        value={data.contact_field_name}
                                                                                        placeholder="Enter Field"
                                                                                        autoFocus
                                                                                        onBlur={() => { onBlurSave(); }}
                                                                                        onKeyDown={(e) => {
                                                                                            if (e.key === "Enter") {
                                                                                                e.preventDefault();
                                                                                                (e.target as HTMLInputElement).blur();
                                                                                            }
                                                                                        }}
                                                                                        onChange={(e) => {
                                                                                            const dummyFields = { ...dummyCampaignContactFieldData };
                                                                                            dummyFields.contact_field_data.map((field, index) => {
                                                                                                if (ind === index) field.contact_field_name = e.target.value;
                                                                                                return field;
                                                                                            })
                                                                                            setDummyCampaignContactFieldData(dummyFields);
                                                                                        }}
                                                                                    />
                                                                                    :
                                                                                    <Typography className={mappingStyles.campaignContactFieldTypography}>
                                                                                        <span className={mappingStyles.fieldNameText}>
                                                                                            {data.contact_field_name}
                                                                                            {isRequiredContactField(data?.contact_field_name) && <Required />}
                                                                                        </span>
                                                                                        {!isDefaultField && (
                                                                                            <span className={mappingStyles.fieldActionIcons}>
                                                                                                <EditOutlinedIcon
                                                                                                    className={mappingStyles.fieldActionIcon}
                                                                                                    onClick={() => onEditFieldClick(data, ind)}
                                                                                                />
                                                                                                <DeleteOutlinedIcon
                                                                                                    className={clsx(mappingStyles.fieldActionIcon, mappingStyles.fieldDeleteIcon)}
                                                                                                    onClick={() => onDeleteFieldClick(data)}
                                                                                                />
                                                                                            </span>
                                                                                        )}
                                                                                    </Typography>
                                                                                }
                                                                            </Grid>
                                                                            <Grid item xs={6}>
                                                                                <Autocomplete
                                                                                    options={dropdownOptions}
                                                                                    // disableClearable
                                                                                    value={mapTheField && mapTheField.length > 0 ? mapTheField[ind] : undefined}
                                                                                    getOptionLabel={(option) => option}
                                                                                    renderInput={(params) => <TextField {...params} placeholder="Select" />}
                                                                                    className={`${globalStyles.autocompleteParaphrasing} ${style.methodAutoComplete}`}
                                                                                    sx={{ boxShadow: "none !important" }}
                                                                                    onChange={(e, newValue) => { handleChangeField(newValue, ind); }}
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    );
                                                                })}
                                                            </Grid>

                                                            <Grid item xs={12} mt={"4px"}>
                                                                <Grid container alignItems={"center"} gap={"0px"}>
                                                                    {editingFieldIndex !== null ? (
                                                                        ((dummyCampaignContactFieldData?.contact_field_data?.[editingFieldIndex]?.contact_field_name?.trim()?.length ?? 0) > 0) && (
                                                                            <Typography component={"span"} className={clsx(globalStyles.tertiaryFontSize, globalStyles.secondaryFontWeight, globalStyles.greyColor)}>
                                                                                Press Enter to {dummyCampaignContactFieldData?.contact_field_data?.[editingFieldIndex]?.contact_field_id ? "save" : "create"} field
                                                                            </Typography>
                                                                        )
                                                                    ) : (
                                                                        <>
                                                                            <AddIcon className={mappingStyles.addFieldIcon} onClick={() => onNewFieldClick()} />
                                                                            <Typography component={"span"} className={mappingStyles.addFieldTypography} onClick={() => onNewFieldClick()}> New Field</Typography>
                                                                        </>
                                                                    )}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={12} marginBlock={"15px"}>
                                                                <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"}>
                                                                    <Grid item>
                                                                        <GlobalButton
                                                                            buttonText="Back"
                                                                            className='borderedButtonStyle'
                                                                            sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                                            onClick={() => { setFlagMapTheField(false); }}
                                                                        >
                                                                        </GlobalButton>
                                                                    </Grid> 
                                                                    <Grid item>
                                                                        <GlobalButton
                                                                            buttonText="Continue"
                                                                            sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                                            className='primaryButtonStyle'
                                                                            disabled={checkDisableContinue()}
                                                                            onClick={() => { onClickOfContinueBtn() }}
                                                                        >
                                                                        </GlobalButton>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CreateNewContactPopup
